/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreNotificationOn = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M5.557 13.25c.246 1.111 1.283 2 2.444 2s2.198-.889 2.444-2H5.557zM1.527 7.641c-.271 0-.493-.28-.5-.552-.044-1.863.64-3.718 1.926-5.067.191-.2.507-.249.707-.061.2.192.207.487.016.686C2.575 3.802 1.989 5.48 2.027 7.076c.006.276-.212.565-.488.565h-.012zM14.473 7.641c.271 0 .493-.28.5-.552.044-1.863-.64-3.718-1.926-5.067-.191-.2-.507-.249-.707-.061a.475.475 0 0 0-.016.686c1.101 1.155 1.687 2.833 1.649 4.429-.006.276.212.565.488.565h.012zM13.371 11.414l-.87-.957V6.75c0-2.21-1.604-4.043-3.708-4.42a.971.971 0 0 0 .208-.58 1 1 0 0 0-2 0c0 .221.086.415.207.58-2.103.377-3.707 2.21-3.707 4.42v3.707l-.87.957a.5.5 0 0 0 .37.836h10a.5.5 0 0 0 .37-.836z"
    />
  </svg>
);

IconCoreNotificationOn.displayName = 'IconCoreNotificationOn';

IconCoreNotificationOn.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreNotificationOn);
IconCoreNotificationOn.displayName = 'IconCoreNotificationOn';
